import { AnyAction } from 'redux';
import { Action, State } from './types';

export const DEFAULT_STATE: State = [];

// eslint-disable-next-line default-param-last
function reducer(state = DEFAULT_STATE, action: AnyAction): State {
  switch (action.type) {
    case Action.MATERIALS_GET_SUCCESS: {
      const { materials } = action.payload;
      return materials;
    }
    default:
      return state;
  }
}

export default reducer;
